import { render, staticRenderFns } from "./land-info.vue?vue&type=template&id=13ecb2ba"
import script from "./land-info.vue?vue&type=script&lang=js"
export * from "./land-info.vue?vue&type=script&lang=js"
import style0 from "./land-info.vue?vue&type=style&index=0&id=13ecb2ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports